// RTDB stores a JSON array as a list, but hands it back as an object keyed by
// string indices ("0", "2", ...) once the indices go sparse - e.g. after a
// lesson is deleted - and a list it does return can carry null holes. Anything
// that walks a stored collection has to survive both shapes: `for...of` throws
// outright on the object form.

export function isObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

/**
 * The object members of a stored collection, in stored order, whichever shape
 * RTDB returned it in.
 * @param {unknown} data
 * @returns {object[]}
 */
export function valuesOf(data) {
  if (Array.isArray(data)) return data.filter(isObject);
  if (isObject(data)) return Object.values(data).filter(isObject);
  return [];
}
